import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setDescription } from '../../helpers/perfil'
import { useForm } from '../../hooks/ useForm'
import { setPerfilDescription } from '../../reducer/PerfilReducer'
import Loading from '../tools/Loading'

const Descripcion = ({description, email}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [edit, setEdit] = useState(false)
    const [values, handleInputChange] = useForm({descrip: description})
    const {descrip} = values;

    const handleSaveDesc = (desc,pemail) => {
        setLoading(true)
        setDescription(desc, pemail)
        .then(() => {
            dispatch(setPerfilDescription(desc));
            setLoading(false)
            setEdit(false)
        })
        .catch(e => {
            console.log(e);
            setLoading(false)
        })
    }


    return (
        edit
        ? 
            <>
                <textarea defaultValue={descrip} name='descrip' onChange={handleInputChange} />
                <div className='cont_perfil_controls'>
                    {
                        loading
                        ? <Loading />
                        :
                            <>
                                <button className='btn_success'
                                    onClick={() => handleSaveDesc(descrip,email)}>Guardar</button>
                                <button className='btn_danger' onClick={() => setEdit(!edit)}>Cancelar</button>
                            </>
                    }
                    
                </div>
            </>
        :
            <>
                <article>
                    <p>{description}</p>
                </article>
                <div className='cont_perfil_controls'>
                    
                    <button className='btn_info' onClick={() => setEdit(!edit)}>Editar</button>
                </div>
            </>
        
    )
}

export default Descripcion
